import PageHeader from "../components/PageHeader";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <PageHeader eyebrow="Legal" title="Terms & Conditions" subtitle="Last updated: November 2025" />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose-blog">
        <p>By accessing or using CashPark Inc's services, you agree to these Terms & Conditions ("Terms"). Please read them carefully.</p>
        <h2>1. Eligibility</h2>
        <p>You must be at least 18 years old, a resident of a supported jurisdiction (Canada and Nigeria), and able to enter into a binding contract. You must complete identity verification before using any transfer services.</p>
        <h2>2. Our services</h2>
        <p>CashPark provides money transfer services between Canadian Dollars (CAD) and Nigerian Naira (NGN). We do not offer investment, lending, or deposit-taking services.</p>
        <h2>3. Exchange rates and fees</h2>
        <p>We display the rate and the applicable margin before you confirm any transfer. The rate is locked at the moment of confirmation. We may change our pricing from time to time, with notice on our website.</p>
        <h2>4. Your obligations</h2>
        <ul>
          <li>Provide accurate, current, and complete information</li>
          <li>Use the service only for lawful purposes</li>
          <li>Not use CashPark for funds derived from or destined for illegal activity</li>
          <li>Maintain the security of your account credentials</li>
        </ul>
        <h2>5. Transfer limits & timing</h2>
        <p>Minimum transfer is CAD 3. Maximum limits depend on your verification tier. Most transfers complete within 10 minutes, but timing may vary based on banking partners and compliance review.</p>
        <h2>6. Cancellations & refunds</h2>
        <p>You may cancel a transfer for a full refund at any time before payout. Once funds are credited to the recipient, the transfer is final and cannot be reversed.</p>
        <h2>7. Liability</h2>
        <p>To the maximum extent permitted by law, CashPark's total liability is limited to the value of the transfer in dispute. We are not liable for indirect or consequential losses, third-party banking delays, or losses due to inaccurate recipient information you provide.</p>
        <h2>8. Termination</h2>
        <p>We may suspend or terminate your account if you breach these Terms, fail KYC checks, or if required by law or regulators.</p>
        <h2>9. Governing law</h2>
        <p>These Terms are governed by the laws of the Province of Alberta and applicable federal laws of Canada. Disputes shall be resolved in the courts of Alberta.</p>
        <h2>10. Contact</h2>
        <p>Questions about these Terms? Email <a href="mailto:contact@mycashpark.com">contact@mycashpark.com</a> or call +1 403 8272668.</p>
      </section>
    </div>
  );
}
